var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDmuDashboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36.148,
    height: 28.556,
    viewBox: "0 0 36.148 28.556",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.423,
    y1: 0.574,
    x2: 0.353,
    y2: 0.952,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#40447e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3c3b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.481,
    y1: 0.467,
    x2: 0.376,
    y2: 0.533,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 0.632,
    y1: 0.116,
    x2: -0.156,
    y2: 2.155,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb827"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#f36f56"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6c6cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#3c3b6b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3c3b6b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 0.585,
    y1: -0.638,
    x2: 0.125,
    y2: 5.923,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#80c1f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 0.445,
    y1: 0.032,
    x2: 0.559,
    y2: 1.589,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#80a5f9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165d7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 0.578,
    y1: -0.519,
    x2: 0.155,
    y2: 5.511,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb503"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 1.547,
    y1: -0.167,
    x2: -0.942,
    y2: 1.416,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 0.5,
    x2: 0.219,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#777beb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000cff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 1.087,
    y1: -0.106,
    x2: -0.471,
    y2: 2.042,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fa9d4e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fb6fbb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 0.45,
    y1: 0.058,
    x2: 0.726,
    y2: 4.145,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#f36f56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 0.577,
    y1: -0.079,
    x2: 0.054,
    y2: 3.019,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f74d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.996,
    stopColor: "#6165d7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6165d7"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_64198",
    "data-name": "Group 64198",
    transform: "translate(-83.872 -366.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64197",
    "data-name": "Group 64197",
    transform: "translate(1125.328 1090.279)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64181",
    "data-name": "Group 64181",
    transform: "translate(-1041.456 -713.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39297",
    "data-name": "Path 39297",
    d: "M477.685,2875.711l-35.791-.267v.788a.433.433,0,0,0,.367.428l10.121,1.552a1.642,1.642,0,0,0,.363.014l24.551-1.769a.419.419,0,0,0,.389-.418Z",
    transform: "translate(-441.536 -2860.021)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_64180",
    "data-name": "Group 64180",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39298",
    "data-name": "Path 39298",
    d: "M436.7,1667.341l-22.432,1.442a.645.645,0,0,1-.728-.612v-14.583a.7.7,0,0,1,.728-.659H436.7a.6.6,0,0,1,.6.6v13.183A.646.646,0,0,1,436.7,1667.341Z",
    transform: "translate(-413.544 -1652.928)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39299",
    "data-name": "Path 39299",
    d: "M465.054,1667.341l-22.432,1.442a.645.645,0,0,1-.728-.612v-14.583a.7.7,0,0,1,.728-.659h22.432a.6.6,0,0,1,.6.6v13.183A.646.646,0,0,1,465.054,1667.341Z",
    transform: "translate(-441.536 -1652.928)",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39300",
    "data-name": "Path 39300",
    d: "M540.722,1732.674l-20.893,1.252a.528.528,0,0,1-.592-.5v-12.767a.57.57,0,0,1,.592-.54l20.893-.079a.489.489,0,0,1,.494.488v11.629A.529.529,0,0,1,540.722,1732.674Z",
    transform: "translate(-517.903 -1719.191)",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39301",
    "data-name": "Path 39301",
    d: "M1410.948,1665.355a.259.259,0,1,1-.258-.245A.253.253,0,0,1,1410.948,1665.355Z",
    transform: "translate(-1397.854 -1664.956)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39302",
    "data-name": "Path 39302",
    d: "M459.65,1663.343c-1.729-.846-3.089.226-4.4-.832-.8-.641-.4-1.12-1.384-2.078-1.084-1.062-1.79-.7-2.88-1.66-1.378-1.208-.689-2.148-1.876-3.015-1.44-1.052-2.992-.078-4.363-1.087a2.99,2.99,0,0,1-1.085-1.741h-1.341a.408.408,0,0,0-.426.387v15.117a.378.378,0,0,0,.426.359l22.862-1.476a.376.376,0,0,0,.276-.153,5.436,5.436,0,0,1-3.359-1.093C460.814,1665.038,461.037,1664.021,459.65,1663.343Z",
    transform: "translate(-441.537 -1652.929)",
    fill: "#fff",
    opacity: 0.48
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_39303",
    "data-name": "Path 39303",
    d: "M465.948,2789.792l-24.054,1.517,10.488,1.608a1.628,1.628,0,0,0,.363.015l24.94-1.8-11.354-1.333A2.109,2.109,0,0,0,465.948,2789.792Z",
    transform: "translate(-441.536 -2775.444)",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39304",
    "data-name": "Path 39304",
    d: "M720.092,2813.079l20.026-1.282,6.2.722-19.853,1.37Z",
    transform: "translate(-716.224 -2797.176)",
    opacity: 0.3,
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64188",
    "data-name": "Group 64188",
    transform: "translate(-1024.413 -709.699)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39321",
    "data-name": "Path 39321",
    d: "M1373.486,2010.552v7.371a.387.387,0,0,0,.381.42l12.363-.741a.415.415,0,0,0,.342-.44v-6.972Z",
    transform: "translate(-1373.486 -2009.313)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39322",
    "data-name": "Path 39322",
    d: "M1386.23,1940.678l-12.363.294a.428.428,0,0,0-.381.452v.755l13.086-.376v-.714A.375.375,0,0,0,1386.23,1940.678Z",
    transform: "translate(-1373.486 -1940.678)",
    fill: "url(#linear-gradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39323",
    "data-name": "Path 39323",
    d: "M1500.233,2125.606l-10.286.561v-5.025l10.286-.345Z",
    transform: "translate(-1488.478 -2118.523)",
    fill: "#f4f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39324",
    "data-name": "Path 39324",
    d: "M1500.233,2213.661l-10.286.561v-3.231c.337,2.18.7,2.649.965,2.658.38.014.584-.882,1.159-.934s.762.8,1.188.747c.81-.1,1.03-3.284,1.687-3.331.521-.038.873,1.939,1.332,1.84.335-.073.416-1.188.67-1.187.23,0,.24.917.542.989.443.1.875-1.759,1.485-1.8.338-.02.759.518,1.257,2.388Z",
    transform: "translate(-1488.478 -2206.579)",
    fill: "url(#linear-gradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39325",
    "data-name": "Path 39325",
    d: "M1417.28,1993.356a.19.19,0,0,1-.169.2.178.178,0,0,1-.169-.192.19.19,0,0,1,.169-.2A.179.179,0,0,1,1417.28,1993.356Z",
    transform: "translate(-1416.395 -1992.502)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64191",
    "data-name": "Group 64191",
    transform: "translate(-1034.735 -723.359)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64189",
    "data-name": "Group 64189",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39326",
    "data-name": "Path 39326",
    d: "M555.359,962.837v10.568a.593.593,0,0,0,.57.626l18.056-.308a.556.556,0,0,0,.489-.6v-9.766Z",
    transform: "translate(-555.359 -961.514)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39327",
    "data-name": "Path 39327",
    d: "M573.984,858.549l-18.056-.591a.582.582,0,0,0-.57.617v1.083l19.114.5v-1A.566.566,0,0,0,573.984,858.549Z",
    transform: "translate(-555.359 -857.957)",
    fill: "url(#linear-gradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39328",
    "data-name": "Path 39328",
    d: "M619.388,904.1a.259.259,0,0,1-.251.274.277.277,0,0,1-.252-.289.258.258,0,0,1,.252-.274A.277.277,0,0,1,619.388,904.1Z",
    transform: "translate(-618.083 -903.234)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64190",
    "data-name": "Group 64190",
    transform: "translate(2.481 3.256)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39329",
    "data-name": "Path 39329",
    d: "M753.466,1123.84l-1.422.016V1116l1.422.028Z",
    transform: "translate(-752.044 -1116.003)",
    fill: "#f4f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39330",
    "data-name": "Path 39330",
    d: "M753.466,1446.664l-1.422.016v-3.729l1.422,0Z",
    transform: "translate(-752.044 -1438.827)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39331",
    "data-name": "Path 39331",
    d: "M909.964,1126.9l-1.4.016v-7.791l1.4.028Z",
    transform: "translate(-906.589 -1119.084)",
    fill: "#f4f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39332",
    "data-name": "Path 39332",
    d: "M909.964,1591.471l-1.4.016v-1.85l1.4-.006Z",
    transform: "translate(-906.589 -1583.657)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39333",
    "data-name": "Path 39333",
    d: "M1064,1129.909l-1.378.016v-7.73l1.378.027Z",
    transform: "translate(-1058.705 -1122.117)",
    fill: "#f4f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39334",
    "data-name": "Path 39334",
    d: "M1064,1658.669l-1.378.016v-.963l1.378-.01Z",
    transform: "translate(-1058.705 -1650.877)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39335",
    "data-name": "Path 39335",
    d: "M1215.639,1132.872l-1.357.016v-7.67l1.357.027Z",
    transform: "translate(-1208.45 -1125.102)",
    fill: "#f4f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39336",
    "data-name": "Path 39336",
    d: "M1215.639,1262.9l-1.357.016v-6.009l1.357.018Z",
    transform: "translate(-1208.45 -1255.13)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39337",
    "data-name": "Path 39337",
    d: "M1364.929,1135.79l-1.336.015v-7.611l1.336.027Z",
    transform: "translate(-1355.877 -1128.041)",
    fill: "#f4f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39338",
    "data-name": "Path 39338",
    d: "M1364.929,1317.835l-1.336.015v-5.285l1.336.014Z",
    transform: "translate(-1355.877 -1310.086)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39339",
    "data-name": "Path 39339",
    d: "M1511.927,1138.663l-1.316.015v-7.552l1.316.026Z",
    transform: "translate(-1501.04 -1130.935)",
    fill: "#f4f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39340",
    "data-name": "Path 39340",
    d: "M1511.927,1224.6l-1.316.015v-6.454l1.316.02Z",
    transform: "translate(-1501.04 -1216.874)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39341",
    "data-name": "Path 39341",
    d: "M1656.686,1141.493l-1.3.015v-7.495l1.3.026Z",
    transform: "translate(-1643.993 -1133.786)",
    fill: "#f4f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39342",
    "data-name": "Path 39342",
    d: "M1656.686,1367.756l-1.3.015v-4.6l1.3.01Z",
    transform: "translate(-1643.993 -1360.05)",
    fill: "url(#linear-gradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39343",
    "data-name": "Path 39343",
    d: "M1799.254,1144.279l-1.276.015v-7.438l1.276.025Z",
    transform: "translate(-1784.782 -1136.593)",
    fill: "#f4f7fa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39344",
    "data-name": "Path 39344",
    d: "M1799.254,1524.228l-1.276.015v-2.582h1.276Z",
    transform: "translate(-1784.782 -1516.542)",
    fill: "url(#linear-gradient-10)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_64196",
    "data-name": "Group 64196",
    transform: "translate(-1035.436 -708.627)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_64192",
    "data-name": "Group 64192",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39345",
    "data-name": "Path 39345",
    d: "M499.788,2084.335v6.135a.317.317,0,0,0,.3.352l9.745-.545a.342.342,0,0,0,.272-.367v-5.856Z",
    transform: "translate(-499.788 -2083.318)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39346",
    "data-name": "Path 39346",
    d: "M509.831,2025.643l-9.745.231a.349.349,0,0,0-.3.376v.629l10.315-.291v-.6A.311.311,0,0,0,509.831,2025.643Z",
    transform: "translate(-499.788 -2025.643)",
    fill: "url(#linear-gradient-18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39347",
    "data-name": "Path 39347",
    d: "M534.008,2068.507a.155.155,0,0,1-.132.167.146.146,0,0,1-.132-.16.155.155,0,0,1,.132-.167A.146.146,0,0,1,534.008,2068.507Z",
    transform: "translate(-533.316 -2067.808)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64193",
    "data-name": "Group 64193",
    transform: "translate(0.654 2.496)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39348",
    "data-name": "Path 39348",
    d: "M561.926,2225.079a.651.651,0,0,1,.459-.41l.014-1.049a1.56,1.56,0,0,0-1.268,1.125Z",
    transform: "translate(-561.012 -2223.618)",
    fill: "url(#linear-gradient-19)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39349",
    "data-name": "Path 39349",
    d: "M673.132,2224.5a.662.662,0,0,1,.5.647l.832.008a1.59,1.59,0,0,0-1.322-1.7Z",
    transform: "translate(-671.599 -2223.449)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39350",
    "data-name": "Path 39350",
    d: "M612.85,2373.563a.69.69,0,0,1-.587.641.479.479,0,0,1-.244-.053l-.443.915a1.172,1.172,0,0,0,.687.183,1.692,1.692,0,0,0,1.419-1.678Z",
    transform: "translate(-610.819 -2371.669)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39351",
    "data-name": "Path 39351",
    d: "M552.233,2329.781l.444-.915a.794.794,0,0,1-.219-.569.935.935,0,0,1,.014-.164l-.795-.333a2.234,2.234,0,0,0-.064.533A1.862,1.862,0,0,0,552.233,2329.781Z",
    transform: "translate(-551.613 -2326.484)",
    fill: "#d8dee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64194",
    "data-name": "Group 64194",
    transform: "translate(3.774 2.391)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39352",
    "data-name": "Path 39352",
    d: "M808.959,2216.744a.635.635,0,0,1,.447-.4l.014-1.035a1.523,1.523,0,0,0-1.233,1.108Z",
    transform: "translate(-808.069 -2215.304)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39353",
    "data-name": "Path 39353",
    d: "M917.127,2216.177a.652.652,0,0,1,.49.639l.809.008a1.565,1.565,0,0,0-1.286-1.681Z",
    transform: "translate(-915.636 -2215.143)",
    fill: "url(#linear-gradient-20)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39354",
    "data-name": "Path 39354",
    d: "M858.488,2363.22a.676.676,0,0,1-.571.632.465.465,0,0,1-.237-.053l-.431.9a1.13,1.13,0,0,0,.668.181,1.661,1.661,0,0,0,1.38-1.655Z",
    transform: "translate(-856.512 -2361.352)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39355",
    "data-name": "Path 39355",
    d: "M799.532,2319.952l.432-.9a.789.789,0,0,1-.214-.561.933.933,0,0,1,.014-.162l-.773-.329a2.24,2.24,0,0,0-.062.526A1.849,1.849,0,0,0,799.532,2319.952Z",
    transform: "translate(-798.929 -2316.7)",
    fill: "#d8dee8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_64195",
    "data-name": "Group 64195",
    transform: "translate(6.809 2.289)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39356",
    "data-name": "Path 39356",
    d: "M1049.267,2208.635a.621.621,0,0,1,.435-.4l.013-1.021a1.488,1.488,0,0,0-1.2,1.093Z",
    transform: "translate(-1048.401 -2207.214)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39357",
    "data-name": "Path 39357",
    d: "M1154.517,2208.082a.642.642,0,0,1,.477.631l.787.009a1.54,1.54,0,0,0-1.251-1.659Z",
    transform: "translate(-1153.066 -2207.062)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39358",
    "data-name": "Path 39358",
    d: "M1097.458,2353.156a.663.663,0,0,1-.556.624.445.445,0,0,1-.231-.053l-.42.889a1.085,1.085,0,0,0,.651.179,1.629,1.629,0,0,0,1.343-1.632Z",
    transform: "translate(-1095.536 -2351.313)",
    fill: "#d8dee8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39359",
    "data-name": "Path 39359",
    d: "M1040.094,2310.393l.42-.89a.785.785,0,0,1-.208-.553.916.916,0,0,1,.014-.16l-.752-.325a2.24,2.24,0,0,0-.061.519A1.837,1.837,0,0,0,1040.094,2310.393Z",
    transform: "translate(-1039.507 -2307.185)",
    fill: "url(#linear-gradient-21)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmuDashboard);
export default __webpack_public_path__ + "static/media/DMUDashboard.9f0913a10d3060dcd4cbf563f046363e.svg";
export { ForwardRef as ReactComponent };